import { render, staticRenderFns } from "./page8.vue?vue&type=template&id=20e82a9c"
import script from "./page8.vue?vue&type=script&lang=js"
export * from "./page8.vue?vue&type=script&lang=js"
import style0 from "./page8.vue?vue&type=style&index=0&id=20e82a9c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports